import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Fragment from "vue-fragment";
import VueTour from "vue-tour";
require("vue-tour/dist/vue-tour.css");
import VueGtag from "vue-gtag";
import { googleAnalyticsId, sentryId } from "./constants/constants";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";

Vue.config.productionTip = false;

Vue.use(Fragment.Plugin);
Vue.use(VueTour);

Vue.use(
  VueGtag,
  {
    config: { id: googleAnalyticsId }
  },
  router
);

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: sentryId,
    integrations: [
      new VueIntegration({
        Vue
      })
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0
  });
}

let mobileDetection = {
  created() {
    window.onresize = () => {
      this.$store.commit("setIsMobile", window.innerWidth < 815);
      this.$store.commit(
        "setIsLandscape",
        window.innerWidth > window.innerHeight
      );
    };
  }
};

Vue.mixin(mobileDetection);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
